import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonAxiosResponse, thunkResponseHandler } from "common";
import {
  EligibleVoucherPayload,
  EligibleVoucherResponse,
  VoucherValidationPayload,
} from "./types";
import { VoucherApi } from "./api";

export const getValidateVoucherThunk = createAsyncThunk<
  CommonAxiosResponse,
  VoucherValidationPayload
>("Voucher/getValidateVoucherThunk ", async (data) => {
  const res = await VoucherApi.getValidVoucher(data);
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});

export const getEligibleVoucherListThunk = createAsyncThunk<
  CommonAxiosResponse<EligibleVoucherResponse>,
  EligibleVoucherPayload
>("Voucher/getEligibleVoucherListThunk ", async (data) => {
  const res = await VoucherApi.getEligibleVoucher(data);
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});
